module.exports = __webpack_public_path__ + "img/cancun-muelle.a798ef50.jpg";